'use strict';
var firstError = true;
var detailsBtnPressed;
var formValidation = require('../components/formValidation');
var createErrorNotification = require('../components/errorNotification');
var accessFocus = require('../accessibilityFocus');
var TencentCaptcha = require('../common/tencentCaptcha');
const scrollAnimate = require('../components/scrollAnimate');
var GrecaptchaV3 = require('../common/grecaptchaV3');

function totalNumberConstraint(pwdValue) {
    return pwdValue.length >= 8;
}

function numberConstraint(pwdValue) {
    return /\d/.test(pwdValue);
}

function uppercaseConstraint(pwdValue) {
    return /[A-Z]/g.test(pwdValue);
}

function lowercaseConstraint(pwdValue) {
    return /[a-z]/g.test(pwdValue);
}

function missingMobilePhone () {
    var $inputPhone = $('input#registration-form-phone');
    var phone = $inputPhone.val();
    var missingMessage = $inputPhone.data('missing-error');
    if (phone !== '' && phone !== undefined && phone !== null) {
        $inputPhone.removeClass('cc-error');
        $inputPhone.parents('.cc-form-group').find('.cc-feedback-message').children('.cc-text-message').empty();
        return true;
    } else {
        erorVerifyCode($inputPhone, missingMessage);
        return false;
    }
}
function erorVerifyCode($selector, errorMessage) {
    // var $inputPhone = $('input#registration-form-phone');
    $selector.addClass('cc-error');
    $selector.parents('.cc-form-group').find('.cc-feedback-message').children('.cc-text-message').text(errorMessage);
}

function startCountDown(resendIntervall, time) {
    var expireTime = resendIntervall - Math.ceil(time);
    var timer = setInterval(function() {
        if (expireTime === 0) {
            clearInterval(timer);
            $('.js-enable-after-captcha').prop('disabled', false);
            $('.cc-timer-to-resend').empty();
            $('.cc-timer-to-resend').css('display', 'none');
            TencentCaptcha.invalidateCaptcha($('.cc-login-page .js-tencent-captcha-container'));
        } else {
            $('.cc-timer-to-resend').css('display', 'unset');
            $('.cc-timer-to-resend').empty().html('(' + expireTime + ')');
            expireTime -= 1;
        }
    }, 1000);
}

function hasClassVisible(formIteam) {
    if ($(formIteam).parent().hasClass('cc-no-visible') || $(formIteam).parent().parent().parent().hasClass('cc-no-visible')) {
        return false;
    }
    return true;
}

function validateForm(form, event) {
    var valid = true;
    firstError = true;
    $(form).find('input').each(function () {
        var isValid = hasClassVisible(this);
        if ((!(this.validity.valid) && isValid)) {
            invalidateForm(this, event);
            if (event) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
            }
            valid = false;
        } else {
            if ($(this).hasClass('cc-error')) $(this).removeClass('cc-error');
            if ($(this).is('input')) {
                $(this).siblings('.cc-feedback-message').children('.cc-text-message').text('');
            } else {
                $(this).parent().parent().siblings('.cc-feedback-message').children('.cc-text-message').text('');
            }
        }
    });

    return valid;
}
 function turnOffPasswordConstraints(){

    $('.js-password-constraints').addClass('d-none');
    $('.js-pwd-totalnumber').removeClass('active-constraint');

    $('.js-pwd-number').removeClass('active-constraint');

    $('.js-pwd-uppercase').removeClass('active-constraint');

    $('.js-pwd-lowercase').removeClass('active-constraint');
}

function invalidateForm (object, e) {
    e.preventDefault();
    if (!$(object).attr('data-no-oriental') === 'false') {
        object.setCustomValidity('');
    }
    if (!object.validity.valid) {
        var validationMessage = object.validationMessage;
        $(object).addClass('cc-error');
        if (object.validity.patternMismatch && $(object).data('pattern-mismatch')) {
            validationMessage = $(object).data('pattern-mismatch');
        }
        if ($(object).attr('data-no-oriental') === 'false') {
            validationMessage = $(object).data('oriental-error');
        }
        if ((object.validity.rangeOverflow || object.validity.rangeUnderflow)
                && $(object).data('range-error')) {
            validationMessage = $(object).data('range-error');
        }
        if ((object.validity.tooLong || object.validity.tooShort)
                && $(object).data('range-error')) {
            validationMessage = $(object).data('range-error');
        }
        if (object.validity.valueMissing && $(object).data('missing-error')) {
            validationMessage = $(object).data('missing-error');
        }
        $(object).parents('.cc-form-group').find('.cc-feedback-message').children('.cc-text-message')
            .text(validationMessage);

        if (firstError) {
            object.focus();
            if (!object) {
                $('.logo-home').focus();
            }
            firstError = false;
        }
    }
}
module.exports = {

    loginForm: function() {
        $(document).on('click', '.js-submit-login', function (e) {
            return validateForm(this.form, e);
        });
    },

    login: function () {
        $(document).on('click', '.js-submit-login', function (e) {
            var form = $('form.login');
            var url = $(this).data('action');
            form.spinner().start();
            $('.cc-icon-eye').siblings('input').attr('type', 'password');
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                        $('form.login').trigger('login:error', data);
                    } else {
                        $('form.login').trigger('login:success', data);
                        location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.login').trigger('login:error', data);
                        form.spinner().stop();
                    }
                }
            });
            return false;
        });
    },
    openResetPwd: function() {
        $(document).on('click', 'form.login #password-reset', function() {
            if (!$('.cc-login-page .js-login').hasClass('cc-hide-form')) {
                $('.cc-login-page .js-login').addClass('cc-hide-form');
                $('.cc-login-page .js-resetpwd').removeClass('cc-hide-form');
                $('.cc-login-page .js-resetpwd .cc-request-reset-OfCanvas-header').addClass('cc-hide-form');
                $('form.cc-resetPwd').removeClass('cc-hide-form');
            }
        });
    },
    closeResetPwd: function() {
        $(document).on('click', 'form .js-return-toLogin', function() {
            if ($(this).hasClass('isCheckout')) {
                $('.js-checkout-psw-reset').addClass('d-none');
                $('.js-login-form').removeClass('d-none');
            } else {
                if (!$('.cc-login-page .js-resetpwd').hasClass('cc-hide-form')) {
                    $('.cc-login-page .js-login').removeClass('cc-hide-form');
                    $('.cc-login-page .js-resetpwd').addClass('cc-hide-form');
                    $('form.cc-resetPwd').addClass('cc-hide-form');
                }
            }
        });
    },
    openResetPwdCheckout: function() {
        $(document).on('click', '#password-reset-checkout', function() {
            $('.js-return-toLogin').addClass('isCheckout');
            $('.js-login-form').addClass('d-none');
            $('.js-checkout-psw-reset').removeClass('d-none');
        });

        $(document).on('keypress', '#password-reset-checkout', function(e) {
            if(e.which == 13) {
                $('.js-return-toLogin').addClass('isCheckout');
                $('.js-login-form').addClass('d-none');
                $('.js-checkout-psw-reset').removeClass('d-none');
            }
        });

    },
    requestResetPwd: function() {
        $('form.cc-resetPwd').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            $('form.resetPwd').trigger('resetpwd:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (data.success) {
                        $('form.cc-resetPwd').empty().html(
                            '<div class="cc-response-message">' +
                            '<p class="cc-succes-text-message">' + data.receivedMsgHeading + '</p>' +
                            '<p class="cc-succes-istruction">' + data.receivedMsgBody + '</p></div>'
                        );
                    } else {
                        $('form.cc-resetPwd').find('#forgotPasswordemail').addClass('.cc-error');
                        $('form.cc-resetPwd').find('.cc-feedback-message .cc-text-message-error').empty().html(data.loginEmail);
                    }
                },
                error: function (data) {
                }
            });
            return false;
        });
    },
    getTencentCode: function () {
        $(document).on('click', '.js-getverifyCode', function() {
            const readyToSubmit = $.Deferred();
            var $tencentCaptcha = $('.cc-login-page .js-tencent-captcha-container');
            var $inputPhone = $('input#registration-form-phone');
            var url = $('.js-getverifyCode').data('action');
            var phone = $inputPhone.val();
            var params = 'SendVerifyCode';

            $('.js-getverifyCode').parents('.cc-form-group').find('.cc-text-message-error').text('');
            $('.js-enable-after-captcha').prop('disabled', true);

            TencentCaptcha.initialize($tencentCaptcha, readyToSubmit);
            readyToSubmit.done(function(promiseData) {
                if (missingMobilePhone()) {
                    $.spinner().start();
                    $.ajax({
                        url: url,
                        type: 'get',
                        dataType: 'json',
                        data: {
                            phone: phone,
                            params: params,
                            tencent_captcha_randstr: promiseData.randstr,
                            tencent_captcha_ticket: promiseData.ticket
                        },
                        success: function (data) {
                            if (!data.success) {
                                erorVerifyCode($inputPhone, data.error);
                                TencentCaptcha.invalidateCaptcha($tencentCaptcha);
                            } else {
                                $('.js-enable-after-captcha').data('smscodetime', data.resendTimout);
                                $('.js-enable-after-captcha').data('interval', data.resendIntervall);
                                $('.js-enable-after-captcha').prop('disabled', true);
                                startCountDown(data.resendIntervall, data.resendTimout);
                            }
                            $.spinner().stop();
                        },
                        error: function (data) {
                            TencentCaptcha.invalidateCaptcha($tencentCaptcha);
                            $.spinner().stop();
                        }
                    });
                }
            }).always(function() {
                $('.js-enable-after-captcha').prop('disabled', false);
            });
        });
    },
    register: function () {
        $('form.registration').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            var checkHoneyPot = $('.contact_me_if_spam').val();
            var isSpam = checkHoneyPot.length > 0 ? true : false;

            const readyToSubmit = $.Deferred();

            function doSubmit() {
                form.spinner().start();
                $('form.registration').trigger('login:register', e);
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: form.serialize(),
                    success: function (data) {
                        form.spinner().stop();
                        if (!data.success) {
                            // analytics
                            dataLayer.push({
                                event: 'registration',
                                eventCategory: 'Registration',
                                eventAction: 'submit_fail'
                            });
                            // END
                            formValidation(form, data);
                        } else {
                            // analytics
                            dataLayer.push({
                                event: 'registration',
                                eventCategory: 'Registration',
                                eventAction: 'submit_ok'
                            });
                            if (data.privacyPress) {
                                dataLayer.push({
                                    event: 'custom_event',
                                    eventCategory: 'Newsletter',
                                    eventAction: 'submit_ok',
                                    eventLabel: 'account_creation'
                                });
                            }
                            // END
                            if (data.newsletterSubscription) {
                                var locale = data.currentLocale;
                                var res = locale.split('_');
                                var language = res[0];
                                var countryCode = res[1];
                                var url = data.newsletterSubscriptionUrl;
                                var email = data.email;
                                $.ajax({
                                    url: url,
                                    type: 'POST',
                                    data: {
                                        email: email,
                                        countryCode: countryCode,
                                        language: language
                                    },
                                    success: function(result) {
                                    },
                                    error: function(richiesta, stato, errori) {
                                    }
                                });
                            }
                            location.href = data.redirectUrl;
                        }
                    },
                    error: function (err) {
                        // analytics
                        dataLayer.push({
                            event: 'registration',
                            eventCategory: 'Registration',
                            eventAction: 'submit_fail'
                        });
                        // END
                        if (err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        } else {
                            createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                            if (err.responseJSON.duplipatePhone) {
                                erorVerifyCode($('input#registration-form-phone'), err.responseJSON.errorMessage);
                            }
                            if (err.responseJSON.wrongVerifyCode) {
                                erorVerifyCode($('input#registration-form-verifyCode'), err.responseJSON.errorMessage);
                            }
                            if (err.responseJSON.recaptchaError) {
                                erorVerifyCode($($(form).find('.cc-recaptcha')[0]), err.responseJSON.errorMessage);
                            }
                        }
                        form.spinner().stop();
                    }
                });
            }

            if (!isSpam) {
                // CAPTCHA handling based on country
                if ($('.js-tencent-captcha-container').length) {
                    doSubmit();
                } else {
                    GrecaptchaV3.initialize(doSubmit);
                }
            }

            return false;
        });

        // fix dropdowns not focusable
        $(document).on('keydown.fixdropdown', (e)=>{
            if (e.key === 'Tab'){
                $('.dropdown-toggle').attr('tabindex', '0');
            }     
        });

        $(document).on('keydown.fixdropdown', '.dropdown:not(.show) .dropdown-toggle', function(e){
            if (e.key === 'Enter' || e.key === ' ') {
                // trigger click and move focus to dropdown items
                $(this)[0].click();
                var $menu = $(this).siblings('.dropdown-menu');
                $menu.find('.dropdown-item')[0].focus();
            }
        });

        $(document).on('keydown.fixdropdown', '.dropdown-item', function(e){
            if (e.key === 'Enter' || e.key === ' ') {
                $(this)[0].click();
            }
        });
    },

    resetPassword: function () {
        $('.reset-password-form').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            $('.reset-password-form').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        $('.request-password-title').text(data.receivedMsgHeading);
                        $('.request-password-body').empty()
                            .append('<p>' + data.receivedMsgBody + '</p>');
                        if (!data.mobile) {
                            $('#submitEmailButton').text(data.buttonText)
                                .attr('data-dismiss', 'modal');
                        } else {
                            $('.send-email-btn').empty()
                                .html('<a href="'
                                    + data.returnUrl
                                    + '" class="btn btn-primary btn-block">'
                                    + data.buttonText + '</a>'
                                );
                        }
                    }
                },
                error: function () {
                    form.spinner().stop();
                }
            });
            return false;
        });
    },

    clearResetForm: function () {
        $('#login .modal').on('hidden.bs.modal', function () {
            $('#reset-password-email').val('');
            $('.modal-dialog .form-control.is-invalid').removeClass('is-invalid');
        });
    },

    checkEmailGuestOrRegistered: function () {
        $('form.logincheckout').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            var checkHoneyPot = $('.contact_me_if_spam').val();
            var isSpam = checkHoneyPot.length > 0 ? true : false;
            var $email = $('#login-form-email');
            var phoneEnabled = $('#js-phoneLoginEnabled').val() === 'true';
            var emailRegex = /[\w\.\%\+\-]+@[\w\.\-]+\.[\w]{2,6}/;
            var emailValid = emailRegex.test($email.val());
            if (phoneEnabled) {
                emailValid = true;
            }
            if (! emailValid) {
                $email.parents('.cc-form-group').find('.cc-feedback-message').children('.cc-text-message')
            .text($email.attr('data-pattern-mismatch'));
            } else {
                $email.parents('.cc-form-group').find('.cc-feedback-message').children('.cc-text-message')
            .text('');
            }
            if (!isSpam && emailValid) {
                form.spinner().start();
                $('form.logincheckout').trigger('logincheckout:submit', e);
                $('.cc-icon-eye').siblings('input').attr('type', 'password');
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: form.serialize(),
                    success: function (data) {
                        if (!data.success && data.error && data.notValid) {
                            $('#login-form-email').parent().children('.cc-feedback-message').children('.cc-text-message').text(data.errorMessage);
                        } else if (!data.success) {
                            formValidation(form, data);
                            $('form.logincheckout').trigger('logincheckout:error', data);
                        } else {
                            if (data.registered === 'false') {
                                $('form.logincheckout').trigger('logincheckout:success', data);
                                location.href = data.redirectUrl;
                            } else {
                                if (data.registered === 'true') {
                                    $('.js-hide-password-checkout-login').removeClass('d-none');
                                    $('#login-form-password').removeAttr('disabled');
                                    $('#login-form-password').focus();
                                    $('#login-form-email').addClass('cc-disabled-email');
                                    $('#login-form-email').attr('readonly', 'true');
                                    $('#login-form-email').removeClass('cc-active');

                                    if (data.showPhoneInputField) {
                                        $('.js-hide-phone-checkout-login').removeClass('d-none');
                                        $('#login-form-phone').removeAttr('disabled');
                                        $('#login-form-phone').focus();
                                    } else {
                                        $('.js-hide-phone-checkout-login').addClass('d-none');
                                    }

                                    $('#registered-guest-link').attr('href', data.registeredGuestUrl);
                                    form.attr('restoreaction', form.attr('action'));
                                    form.attr('action', data.actionUrl);
                                    var text = $('#button-checkout-login').attr('textregistered');
                                    $('#button-checkout-login').text(text);
                                    if ($(window).width() < 500) {
                                        if ($('#checkout_v2').length) {
                                            var top = $('.js-focus-mobile-password').offset().top;
                                        } else {
                                            var top = $('.js-mobile-scroll-password').offset().top;
                                        }
                                        scrollAnimate(0, {duration: 100});
                                    }
                                    document.getElementById('login-form-password').click();
                                    // analytics
                                    dataLayer.push({
                                        event: 'checkoutOption',
                                        ecommerce: {
                                            checkout_option: {
                                                actionField: { step: 2, option: 'insert_password' }
                                            }
                                        }
                                    });
                                    // END
                                } else {
                                    $('form.logincheckout').trigger('logincheckout:success', data);
                                    location.href = data.redirectUrl;
                                }
                            }
                        }
                        form.spinner().stop();
                    },
                    error: function (data) {
                        if (data.responseJSON.redirectUrl) {
                            window.location.href = data.responseJSON.redirectUrl;
                        } else {
                            $('form.login').trigger('login:error', data);
                            form.spinner().stop();
                        }
                    }
                });
            }
            return false;
        });
    },

    changeEmailCheckoutLogin: function () {
        $(document).on('click', '.js-change-email-checkout', function () {
            var restoreUrl = $('#checkoutLoginForm').attr('restoreaction');
            $('#checkoutLoginForm').attr('action', restoreUrl);
            $('#checkoutLoginForm').removeAttr('restoreaction');
            $('.js-hide-password-checkout-login').addClass('d-none');
            $('#login-form-phone').attr('disabled', true);
            $('#login-form-password').attr('disabled', 'true');
            $('#login-form-email').removeClass('cc-disabled-email');
            $('#login-form-email').addClass('cc-active');
            $('#login-form-email').removeAttr('readonly');
            $('#login-form-email').val('');
            $('#login-form-email').removeClass('cc-error');
            var text = $('#button-checkout-login').attr('textcheck');
            $('#button-checkout-login').text(text);
        });

        $(document).on('keypress', '.js-change-email-checkout', function(e) {
            if(e.which == 13) {
                var restoreUrl = $('#checkoutLoginForm').attr('restoreaction');
                $('#checkoutLoginForm').attr('action', restoreUrl);
                $('#checkoutLoginForm').removeAttr('restoreaction');
                $('.js-hide-password-checkout-login').addClass('d-none');
                $('#login-form-phone').attr('disabled', true);
                $('#login-form-password').attr('disabled', 'true');
                $('#login-form-email').removeClass('cc-disabled-email');
                $('#login-form-email').addClass('cc-active');
                $('#login-form-email').removeAttr('readonly');
                $('#login-form-email').val('');
                $('#login-form-email').removeClass('cc-error');
                var text = $('#button-checkout-login').attr('textcheck');
                $('#button-checkout-login').text(text);
            }
        });
    },

    registrationFirstStep: function (e) {
        $('form.registrationemail').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            $('form.registrationemail').trigger('registrationemail:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (data.success) {
                        $('.cc-mail-value').text(data.email);
                        $('.js-email-second-step-registration').val(data.email);
                        $('form.js-second-step-reg').attr('action', data.actionurl);
                        $('.cc-header-container').addClass('cc-second-step');
                        $('.cc-step-title-container').addClass('cc-second-step');
                        if ($(document.body).hasClass('cc-mobile')) {
                            $('.cc-step-title-container').addClass('js-back-first-step-mobile');
                        }

                        $('.cc-registration-step-1').addClass('d-none');
                        $('.cc-registration-step-2').removeClass('d-none');

                        // analytics
                        $('body').trigger('analytics:pushpagechange', { pageDetail: 'step2' });
                        $('body').trigger('analytics:dataLayerPushObj', {
                            event: 'registration',
                            eventCategory: 'Registration',
                            eventAction: 'step_2'
                        });

                        // END
                    } else {
                        $('#registration-form-email').parent().children('.cc-feedback-message').children('.cc-text-message').text(data.errorMessage);
                        $('#registration-form-email').addClass('cc-error');
                    }
                },
                error: function (data) {
                    form.spinner().stop();
                    return false;
                }
            });
        });
    },
    backToFirstStepRegistration: function () {
        $(document).on('click', '.js-back-to-first-step', function () {
            $('.cc-step-title-container').removeClass('cc-second-step');
            $('.cc-registration-step-1, .cc-registration-step-2').toggleClass('d-none');
            $('#emailRegistrationForm').trigger('reset');
            turnOffPasswordConstraints();

            // analytics
            $('body').trigger('analytics:pushpagechange', { pageDetail: 'step1' });
            // END
        });
    },

    backToFirstStepRegistrationMobile: function () {
        $(document).on('click', '.cc-mobile .js-back-first-step-mobile', function () {
            $('.cc-step-title-container').removeClass('cc-second-step');
            $('.cc-registration-step-1, .cc-registration-step-2').toggleClass('d-none');
            $('#emailRegistrationForm').trigger('reset');
            turnOffPasswordConstraints();
            // analytics
            dataLayer.push({
                pageDetail: 'step1'
            });
            // END
        });
    },

    passwordConstraintsShow: function () {
        $(document).on('click', '.js-password-registration', function () {
            $('.js-password-constraints').removeClass('d-none');
        });
    },

    passwordConstraintsCheck: function () {
        $(document).on('input', '.js-password-registration', function () {
            var pwdValue = $(this).val();
            
            if (totalNumberConstraint(pwdValue)) {
                $('.js-pwd-totalnumber').removeClass('active-constraint').addClass('active-constraint');
                $('.registration-second-contraints').text($('.sr-only.registration-second-contraints').attr('data-accessible-success'));
            } else {
                $('.js-pwd-totalnumber').removeClass('active-constraint');
                $('.registration-second-contraints').text($('.sr-only.registration-second-contraints').attr('data-accessible-failed'));
            }
            if (numberConstraint(pwdValue)) {
                $('.js-pwd-number').removeClass('active-constraint').addClass('active-constraint');
                $('.registration-third-contraints').text($('.sr-only.registration-third-contraints').attr('data-accessible-success'));
            } else {
                $('.js-pwd-number').removeClass('active-constraint');
                $('.registration-third-contraints').text($('.sr-only.registration-third-contraints').attr('data-accessible-failed'));
            }
            if (uppercaseConstraint(pwdValue)) {
                $('.js-pwd-uppercase ').removeClass('active-constraint').addClass('active-constraint');
                $('.registration-fourth-contraints').text($('.sr-only.registration-fourth-contraints').attr('data-accessible-success'));
            } else {
                $('.js-pwd-uppercase').removeClass('active-constraint');
                $('.registration-fourth-contraints').text($('.sr-only.registration-fourth-contraints').attr('data-accessible-failed'));
            }
            if (lowercaseConstraint(pwdValue)) {
                $('.js-pwd-lowercase').removeClass('active-constraint').addClass('active-constraint');
                $('.registration-fifth-contraints').text($('.sr-only.registration-fifth-contraints').attr('data-accessible-success'));
            } else {
                $('.js-pwd-lowercase').removeClass('active-constraint');
                $('.registration-fifth-contraints').text($('.sr-only.registration-fifth-contraints').attr('data-accessible-failed'));
            }
            if (totalNumberConstraint(pwdValue) && numberConstraint(pwdValue) && uppercaseConstraint(pwdValue) && lowercaseConstraint(pwdValue)) {
                $('#form-password-error').children().text('');
            }
        });
    },

    openRegistrationBenefits: function () {
        $(document).on('click', '.cc-mobile .js-open-registration-benefits', function () {
            if ($(this).hasClass('cc-list-benefits-open')) {
                $(this).removeClass('cc-list-benefits-open');
                $('.cc-benefits-list-container').css('display', 'none');
            } else {
                $(this).addClass('cc-list-benefits-open');
                $('.cc-benefits-list-container').css('display', 'block');
            }
        });
    },

    showQuickView: function () {
        $(document).on('click', '.js-open-quick-view, .js-item', function () {
            $('.js-quick-view').removeClass('d-none');
            detailsBtnPressed = $(this)[0];
        });

        $(document).on('click', '#js-close-quick-view-modal', function () {
            $('.js-quick-view').addClass('d-none');
            detailsBtnPressed.focus();
        });
    },
    // reset password
    submitPassword: function () {
        $('form.js-resetPwd-Form').submit(function (e) {
            var $form = $(this);
            e.preventDefault();
            var url = $form.attr('action');
            $form.spinner().start();
            $('form.js-edit-password-form').trigger('password:reset', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    $form.spinner().stop();
                    if (!data.success) {
                        if (data.invalidToken) {
                            location.href = data.redirectUrl;
                        } else {
                            $('form.js-resetPwd-Form input').addClass('cc-error');
                            if (data.fields.dwfrm_newPasswords_newpassword) {
                                $('.cc-text-message.cc-text-message-error').html(data.fields.dwfrm_newPasswords_newpassword);
                            } else {
                                $('.cc-text-message.cc-text-message-error').html(data.fields.dwfrm_newPasswords_newpasswordconfirm);
                            }
                        }
                    } else {
                        location.href = data.redirectUrl;
                    }
                },
                error: function (err) {
                    if (err && err.responseJSON && err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    $form.spinner().stop();
                }
            });
            return false;
        });
    },

    showQuickViewItem: function () {
        $(document).on('click', '.js-open-quick-view, .js-item', function () {
            var $item = $(this).is('.js-item') ? $(this) : $(this).closest('.js-item');
            var productName = $item.find('.js-item-title').data('productname');
            var sku = $item.find('.js-item-sku').data('sku');
            var color = $item.find('.js-item-info').data('attr1');
            var size = $item.find('.js-item-info').data('attr2');
            var quantity = $item.find('.js-quantity').data('quantity');
            var price = $item.find('.js-item-price').data('price');
            var src = $item.find('.js-content-img').data('src');
            var longDesc = $item.data('longdesc').replaceAll('\n', '<br />');
            var details = '<li>' +  $item.data('details').replaceAll('\n', '</li><li>') + '</li>';
            var materials = '<li>' +  $item.data('materials').replaceAll('\n', '</li><li>') + '</li>';
            var materialCare = $item.data('material-care').replaceAll('\n', '<br />');
            var madeinitaly = $item.data('madeinitaly').replaceAll('\n', '<br />');
            var washing = $item.data('washing').replaceAll('\n', '<br />');
            var washingInfo = $item.data('washing-info').replaceAll('\n', '<br />');

            var temp = quantity.split('.');
            quantity = temp[0];

            $('.js-quick-img').attr('src', src);
            $('.js-quick-img').attr('alt', '');
            $('.js-quick-product-name').text(productName);
            $('.js-quick-sku').text(sku);
            $('.js-quick-color').text(color);
            $('.js-quick-size').text(size);
            $('.js-quick-quantity').text(quantity);
            $('.js-quick-cost').text(price);
            $('.js-quick-longDesc').html(longDesc);
            $('.js-quick-details').html(details + '<br/><br/>' + materials);
            $('.js-quick-materials').html(materialCare + '<br/><br/>' + madeinitaly + '<br/><br/>' + washing + '<br/><br/>' + washingInfo);

            $('.js-quick-view').removeClass('d-none');
            accessFocus.focusOnFirstElement('.js-quick-view-modal-content');
            accessFocus.focuseOnModal('.js-quick-view-modal-content', detailsBtnPressed, '.js-quick-view');
            // accessibility: disable interactive elements on the background
            accessFocus.disableBackgroundElements('.js-quick-view-modal-content');
            // accessibility: reactivate interactive elements on the background previously disabled
            $(document).on('click', '#js-close-quick-view-modal', function () {
                $(document.body).removeAttr('aria-hidden aria-disabled');
            });
            // accessibility focus on corresponding text when activating a tab
            $(document).on('keydown', '.cc-tab-head-item-link', function(event){
                if (event.key === 'Enter' || event.key === ' '){
                    if (event.key === ' ') {
                        event.preventDefault();
                        $(this)[0].click();
                    }
                    setTimeout(() => {
                        $('.tab-pane:not(.active)').attr('tabindex', '-1');
                        $('.tab-pane.active').attr('tabindex','0');
                    }, 0);
                }

                // move between tabs with arrow keys
                if (event.key === 'ArrowLeft') {
                    var $prev = $(this).parent().prev('.cc-tab-head-item');
                    if ($prev.length) {
                        $prev.find('.cc-tab-head-item-link').focus();
                    }
                }
                else if (event.key === 'ArrowRight') {
                    var $next = $(this).parent().next('.cc-tab-head-item');
                    if ($next.length) {
                        $next.find('.cc-tab-head-item-link').focus();
                    }
                }
            });
        });

        $(document).on('click', '#js-close-quick-view-modal', function () {
            $('.js-quick-view').addClass('d-none');
        });
    },

    noOrientalCheck: function () {
        $(document).on('focusout', '.js-no-oriental', function () {
            var validationMsg = $('#js-oriental-error-registration').val();
            var regex = /^[a-zA-Z0-9 -_\/(){}|"!? ’'‘ÆÐƎƏƐƔĲŊŒẞÞǷȜæðǝəɛɣĳŋœĸſßþƿȝĄƁÇĐƊĘĦĮƘŁØƠŞȘŢȚŦŲƯY̨Ƴąɓçđɗęħįƙłøơşșţțŧųưy̨ƴÁÀÂÄǍĂĀÃÅǺĄÆǼǢƁĆĊĈČÇĎḌĐƊÐÉÈĖÊËĚĔĒĘẸƎƏƐĠĜǦĞĢƔáàâäǎăāãåǻąæǽǣɓćċĉčçďḍđɗðéèėêëěĕēęẹǝəɛġĝǧğģɣĤḤĦIÍÌİÎÏǏĬĪĨĮỊĲĴĶƘĹĻŁĽĿʼNŃN̈ŇÑŅŊÓÒÔÖǑŎŌÕŐỌØǾƠŒĥḥħıíìiîïǐĭīĩįịĳĵķƙĸĺļłľŀŉńn̈ňñņŋóòôöǒŏōõőọøǿơœŔŘŖŚŜŠŞȘṢẞŤŢṬŦÞÚÙÛÜǓŬŪŨŰŮŲỤƯẂẀŴẄǷÝỲŶŸȲỸƳŹŻŽẒŕřŗſśŝšşșṣßťţṭŧþúùûüǔŭūũűůųụưẃẁŵẅƿýỳŷÿȳỹƴźżžẓ]+$/;
            var value = $(this).val();
            var valid = regex.test(value);
            if (value && value !== '') {
                if (!valid) {
                    $(this)
                        .addClass('cc-error')
                        .siblings('.cc-feedback-message').children('.cc-text-message')
                        .text(validationMsg);
                } else {
                    if ($(this).hasClass('cc-error')) {
                        $(this)
                            .removeClass('cc-error')
                            .siblings('.cc-feedback-message').children('.cc-text-message')
                            .text('');
                    }
                }
            }
        });
    },

    alignUnder: function () {
        $(document).ready( function () {
            var price = $( "div.line-item-total-price-amount" ).text() ;
            if(price.length > 12){ 
                $('.js-align-under').addClass('cc-align-under');
            }
        });
    },

    pushPageOnload: function() {
        $(document).ready(function() {
            var isRegistrationStep = $('.js-analytics-registration');
            if (isRegistrationStep.length) {
                $('body').trigger('analytics:dataLayerPushObj', {
                    event: 'registration',
                    eventCategory: 'Registration',
                    eventAction: 'step_1'
                });
            }
        });
    },
};

$('#registration-form-email').on('keyup', function(e) {
    var regex = /^[\w.%+\-]+@[\w.\-]+\.[\w]{2,6}/;
    var email = $('#registration-form-email').val();
    if (regex.test(email)) {
        $('#registration-form-email').parent().children('.cc-feedback-message').children('.cc-text-message').text('');
        $('#registration-form-email').removeClass('cc-error');
    }
});
